import { Directive, HostListener, Input } from '@angular/core';
import { Router } from '@angular/router';
import { Booth, Hall } from '@planone/shared/util-interfaces';

@Directive({ selector: '[planoneLocationLink]' })
export class LocationLinkDirective {
  @Input() booth?: Booth;
  @Input() hall?: Hall;
  @Input() fairId?: string;
  @Input() clickable = true;

  @HostListener('click', ['$event']) click(event: Event) {
    if (!this.hall || !this.booth || !this.clickable) return;
    event.preventDefault();
    event.stopPropagation();
    this.router.navigate(['/fairs', this.fairId, 'hall-plan'], {
      queryParams: { hall: this.hall.name, booth: this.booth.name },
    });
  }

  constructor(private router: Router) {}
}
